import { BaseForm } from 'src/app/common/form/base-Form';
import {ServicesSearch} from '../search/services/search.service';
import {
  AssegnazioneCompetenzaFormComponent
} from './components/assegnazione/competenza/assegnazione-competenza-form.component';
import {RifiutoComponent} from './components/assegnazione/rifiuto/rifiuto.component';
import {DocumentoAddForm} from './components/documenti/documento-add/documento-add-form.component';
import {DocumentoAddModal} from './components/documenti/documento-add/documento-add-modal.component';
import {
  DocumentVersionHistoryModal
} from './components/documenti/documento-history-version/document-version-history-modal.component';
import {
  DocumentVersionHistoryComponent
} from './components/documenti/documento-history-version/documento-version-history.component';
import {
  DocumentUpdateMetadatiModal
} from './components/documenti/documento-update-metadati/document-update-metadati-modal.component';
import {
  DocumentUpdateMetadatiFormComponent
} from './components/documenti/documento-update-metadati/documento-update-metadati-form.component';
import {
  DocumentVersionUpdateModal
} from './components/documenti/documento-version-update/document-version-update-modal.component';
import {
  DocumentVersionUpdateFormComponent
} from './components/documenti/documento-version-update/documento-version-update-form.component';
import {
  ListaDocumentiDiSezioneComponent
} from './components/documenti/lista-documenti-di-sezione/lista-documenti-di-sezione.component';
import {ListaDocumentiComponent} from './components/documenti/lista-documenti/lista-documenti.component';
import {ExportHelpComponent} from './components/export-help/export-help.component';
import {
  AltrePartiAssociativaAddComponent
} from './components/fascicolo/altre-parti-add/altre-parti-associativa-add.component';
import {AltrePartiModAggiungi} from './components/fascicolo/altre-parti-add/altre-parti-mod-aggiungi';
import {
  AltrePartiUpdateAssociativaComponent
} from './components/fascicolo/altre-parti-update/altre-parti-update-associativa.component';
import {
  AltrePartiModAssociativaUpdate
} from './components/fascicolo/altre-parti-update/altreparti-mod-associativa-update';
import {
  AltrePartiAnagraficaViewComponent
} from './components/fascicolo/altreparti-anagrafica-view/altreparti-anagrafica-view.component';
import {AssegnatariModalComponent} from './components/fascicolo/assegnatari-view/assegnatari-modal.component';
import {AttiAddConcreteFormComponent} from './components/fascicolo/atti-add/atti-add-concrete-form.component';
import {AttiModAdd} from './components/fascicolo/atti-add/atti-mod-add.component';
import {
  ContropartiAssociativaAddComponent
} from './components/fascicolo/controparti-add/controparti-associativa-add.component';
import {AttiModModify} from './components/fascicolo/atti-update/atti-mod-modify.component';
import {AttiModifyConcreteFormComponent} from './components/fascicolo/atti-update/atti-modify-concrete-form.component';
import {BeniImmobiliAddComponent} from './components/fascicolo/beni-immobili-add/beni-immobili-add.component';
import {BeniImmobiliModAddComponent} from './components/fascicolo/beni-immobili-add/beni-immobili-mod-add.component';
import {
  BeniImmobiliModUpdateComponent
} from './components/fascicolo/beni-immobili-update/beni-immobili-mod-update.component';
import {BeniImmobiliUpdateComponent} from './components/fascicolo/beni-immobili-update/beni-immobili-update.component';
import {BeniMobiliAddComponent} from './components/fascicolo/beni-mobili-add/beni-mobili-add.component';
import {BeniMobiliModAdd} from './components/fascicolo/beni-mobili-add/beni-mobili-mod-add.component';
import {BeniMobiliModUpdate} from './components/fascicolo/beni-mobili-update/beni-mobili-mod-update.component';
import {BeniMobiliUpdateComponent} from './components/fascicolo/beni-mobili-update/beni-mobili-update.component';
import {ContropartiModAggiungi} from './components/fascicolo/controparti-add/controparti-mod-aggiungi';
import {
  ContropartiAnagraficaViewComponent
} from './components/fascicolo/controparti-anagrafica-view/controparti-anagrafica-view.component';
import {
  ContropartiAssociativaUpdateComponent
} from './components/fascicolo/controparti-associativa-update/controparti-associativa-update.component';
import {
  ContropartiModAssociativaUpdate
} from './components/fascicolo/controparti-associativa-update/controparti-mod-associativa-update';
import {DatiFascicoloComponent} from './components/fascicolo/dati-fascicolo-view/dati-fascicolo-view.component';
import {EsitiAddMod} from './components/fascicolo/esiti-add/esiti-add-mod.component';
import {EsitiAddComponent} from './components/fascicolo/esiti-add/esiti-add.component';
import {EsitiMeritoAddMod} from './components/fascicolo/esiti-add/esiti-merito-add-mod.component';
import {EsitiMeritoAddComponent} from './components/fascicolo/esiti-add/esiti-merito-add.component';
import {EsitiDatiGeneraliUpdateMod} from './components/fascicolo/esiti-update/esiti-dati-generali-update-mod.component';
import {EsitiDatiGeneraliComponent} from './components/fascicolo/esiti-update/esiti-dati-generali.component';
import {EsitiMeritoUpdate} from './components/fascicolo/esiti-update/esiti-merito-update';
import {EsitiMeritoUpdateMod} from './components/fascicolo/esiti-update/esiti-merito-update-mod.component';
import {FatturaModAdd} from './components/fascicolo/fatture-add/fattura-mod-add';
import {FattureAddComponent} from './components/fascicolo/fatture-add/fatture-add.component';
import {FatturaModEdit} from './components/fascicolo/fatture-edit/fattura-mod-edit';
import {FattureEditComponent} from './components/fascicolo/fatture-edit/fatture-edit.component';
import {IncassiAddComponent} from './components/fascicolo/incassi-add/incassi-add.component';
import {IncassoModAdd} from './components/fascicolo/incassi-add/incasso-mod-add';
import {IncassiEditComponent} from './components/fascicolo/incassi-edit/incassi-edit.component';
import {IncassoModEdit} from './components/fascicolo/incassi-edit/incasso-mod-edit';
import {IntestazioneComponent} from './components/fascicolo/intestazione/intestazione.component';
import {
  LegaleAnagraficaViewComponent
} from './components/fascicolo/legale-anagrafica-view/legale-anagrafica-view.component';
import {LegaleAnagraficaAddComponent} from './components/fascicolo/legali-add/legale-anagrafica-add.component';
import {LegaliAssociativaAddComponent} from './components/fascicolo/legali-add/legali-associativa-add.component';
import {LegaliModAggiungi} from './components/fascicolo/legali-add/legali-mod-aggiungi';
import {
  LegaleAnagraficaUpdate
} from './components/fascicolo/legali-anagrafica-update/legali-anagrafica-update.component';
import {LegaliModAnagraficaUdate} from './components/fascicolo/legali-anagrafica-update/legali-mod-anagrafica-udate';
import {
  LegaliAssociativaUpdateComponent
} from './components/fascicolo/legali-associativa-update/legali-associativa-update.component';
import {LegaliModAssociativaUdate} from './components/fascicolo/legali-associativa-update/legali-mod-associativa-udate';
import {PagamentiAddComponent} from './components/fascicolo/pagamenti-add/pagamenti-add.component';
import {PagamentoModAdd} from './components/fascicolo/pagamenti-add/pagamento-mod-add';
import {PagamentiEditComponent} from './components/fascicolo/pagamenti-edit/pagamenti-edit.component';
import {PagamentoModEdit} from './components/fascicolo/pagamenti-edit/pagamento-mod-edit';
import {ParcellaGiudizialeModAdd} from './components/fascicolo/parcelle-giudiziali-add/parcella-giudiziale-mod-add';
import {
  ParcelleGiudizialiAddComponent
} from './components/fascicolo/parcelle-giudiziali-add/parcelle-giudiziali-add.component';
import {ParcellaGiudizialeModEdit} from './components/fascicolo/parcelle-giudiziali-edit/parcella-giudiziale-mod-edit';
import {
  ParcelleGiudizialiEditComponent
} from './components/fascicolo/parcelle-giudiziali-edit/parcelle-giudiziali-edit.component';
import {
  ParteAnagraficaAddComponent
} from './components/fascicolo/parte-anagrafica-update/parte-anagrafica-add.component';
import {
  ParteAnagraficaUpdateComponent
} from './components/fascicolo/parte-anagrafica-update/parte-anagrafica-update.component';
import {ParteModAnagraficaUdate} from './components/fascicolo/parte-anagrafica-update/parte-mod-anagrafica-udate';
import {ProvaScrittaModAddComponent} from './components/fascicolo/prove-scritte-add/prova-scritta-mod-add.component';
import {ProveScritteAddFormComponent} from './components/fascicolo/prove-scritte-add/prove-scritte-add-form.component';
import {
  ScadenzaAddConcreteFormComponent
} from './components/fascicolo/scadenzario-add/scadenza-add-concrete-form.component';
import {ScadenzaModAddComponent} from './components/fascicolo/scadenzario-add/scadenza-mod-add.component';
import {
  ScadenzaListRinviiConcreteFormComponent
} from './components/fascicolo/scadenzario-list-rinvii/scadenza-list-rinvii-concrete-form.component';
import {
  ScadenzaModListRinviiComponent
} from './components/fascicolo/scadenzario-list-rinvii/scadenza-mod-list-rinvii.component';
import {ScadenzaModRinvioComponent} from './components/fascicolo/scadenzario-rinvio/scadenza-mod-rinvio.component';
import {
  ScadenzaRinvioConcreteFormComponent
} from './components/fascicolo/scadenzario-rinvio/scadenza-rinvio-concrete-form.component';
import {ScadenzaModModifyComponent} from './components/fascicolo/scadenzario-update/scadenza-mod-modify.component';
import {
  ScadenzaUpdateConcreteFormComponent
} from './components/fascicolo/scadenzario-update/scadenza-update-concrete-form.component';
import {
  SezioneEconomicaFondoOneriAddComponent
} from './components/fascicolo/sezione-economica-fondo-oneri-add/sezione-economica-fondo-oneri-add.component';
import {
  SezioneEconomicaFondoOneriModAddComponent
} from './components/fascicolo/sezione-economica-fondo-oneri-add/sezione-economica-mod-fondo-oneri-add.component';
import {
  SezioneEconomicaFondoOneriUpdateComponent
} from './components/fascicolo/sezione-economica-fondo-oneri-update/sezione-economica-fondo-oneri-update.component';
import {
  SezioneEconomicaFondoOneriModUpdateComponent
} from './components/fascicolo/sezione-economica-fondo-oneri-update/sezione-economica-mod-fondo-oneri-update.component';
import {CheckBoxModComponent} from './components/input-component/checkboxMod/checkbox.component';
import {CheckListComponent} from './components/input-component/checklist/check-list.component';
import {ComboModComponent} from './components/input-component/comboMod/comboMod.component';
import {DatePickerComponent} from './components/input-component/datepicker/date-picker.component';
import {FileInputComponent} from './components/input-component/file-input/file-input.component';
import {InputTextComponent} from './components/input-component/inputText/input-text.component';
import {InputTextCurrencyComponent} from './components/input-component/inputTextCurrency/input-text-currency.component';
import {
  InputTextReadOnlyComponent
} from './components/input-component/inputTextReadOnly/input-text-read-only.component';
import {OraComboComponent} from './components/input-component/oraCombo/oraCombo.component';
import {SearchTextComponent} from './components/input-component/searchText/search-text.component';
import {SpinnerComponent} from './components/input-component/submitButton/spinner.component';
import {SubmitButtonComponent} from './components/input-component/submitButton/submit-button.component';
import {TextAreaComponent} from './components/input-component/textarea/textarea.component';
import {FascicoloSelectModal} from './components/option-component/aggiungiFascicolo/fascicolo-select-modal.component';
import {DefineFascicoloComponent} from './components/option-component/definisciFascicolo/define-fascicolo.component';
import {DepositoPctComponent} from './components/option-component/depositoPct/deposito-pct.component';
import {DeletePraticaComponent} from './components/option-component/deletePratica/delete-pratica.component';
import {
  ClassificazioneModAddComponent
} from './components/pratica/classificazione/add/classificazione-mod-add.component';
import {
  ClassificazionePraticaAddComponent
} from './components/pratica/classificazione/add/classificazione-pratica-add.component';
import {
  ClassificazioneModUpdateComponent
} from './components/pratica/classificazione/classificazione-mod-update.component';
import {
  ClassificazionePraticaUpdateComponent
} from './components/pratica/classificazione/classificazione-pratica-update.component';
import {ClassificazionePraticaComponent} from './components/pratica/classificazione/classificazione-pratica.component';
import {IntestazionePraticaComponent} from './components/pratica/intestazione/intestazione-pratica.component';
import {AddDocumentoToAltraParteComponent} from './form/documento/add-to-altraparte/add-to-altraparte.component';
import {AddDocumentoToAttoComponent} from './form/documento/add-to-atto/add-to-atto.component';
import {AttoEntityViewComponent} from './form/documento/add-to-atto/atto-entity-view.component';
import {AddDocumentoToControparteComponent} from './form/documento/add-to-controparte/add-to-controparte.component';
import {ControparteEntityViewComponent} from './form/documento/add-to-controparte/controparte-entity-view.component';
import {AddDocumentoToEsitoComponent} from './form/documento/add-to-esito/add-to-esito.component';
import {EsitoEntityViewComponent} from './form/documento/add-to-esito/esito-entity-view.component';
import {AddDocumentoToFatturaComponent} from './form/documento/add-to-fattura/add-to-fattura.component';
import {FatturaEntityViewComponent} from './form/documento/add-to-fattura/fattura-entity-view.component';
import {AddDocumentoToIncassoComponent} from './form/documento/add-to-incasso/add-to-incasso.component';
import {IncassoEntityViewComponent} from './form/documento/add-to-incasso/incasso-entity-view.component';
import {AddDocumentoToLegaleComponent} from './form/documento/add-to-legale/add-to-legale.component';
import {
  LegaleIncaricatoEntityViewComponent
} from './form/documento/add-to-legale/legale-incaricato-entity-view.component';
import {AddDocumentoToPagamentoComponent} from './form/documento/add-to-pagamento/add-to-pagamento.component';
import {PagamentoEntityViewComponent} from './form/documento/add-to-pagamento/pagamento-entity-view.component';
import {AddDocumentoToParcellaComponent} from './form/documento/add-to-parcella/add-to-parcella.component';
import {ParcellaEntityViewComponent} from './form/documento/add-to-parcella/parcella-entity-view.component';
import {AddDocumentoToScadenzaComponent} from './form/documento/add-to-scadenza/add-to-scadenza.component';
import {ScadenzaEntityViewComponent} from './form/documento/add-to-scadenza/scadenza-entity-view.component';
import {FatturaRiepilogoForm} from './form/fattura-riepilogo-form';
import {ParcellaGiudizialeQuadroForm} from './form/parcelle/giudiziali/parcella-giudiziale-quadro-form';
import {ParcellaGiudizialeRiepilogoForm} from './form/parcelle/giudiziali/parcella-giudiziale-riepilogo-form';
import {RicercaAnagraficheFormComponent} from './form/ricerca-anagrafiche-form.component';
import {LettereDiffidaAddComponent} from './components/fascicolo/lettere-diffida-add/lettere-diffida-add.component';
import {LettereDiffidaAddMod} from './components/fascicolo/lettere-diffida-add/lettere-diffida-add-mod.component';
import {
  LettereDiffidaEsitoSpedizioneAddComponent
} from './components/fascicolo/lettere-diffida-add/lettere-diffida-esito-spedizione-add.component';
import {
  LettereDiffidaEsitoSpedizioneAddMod
} from './components/fascicolo/lettere-diffida-add/lettere-diffida-esito-spedizione-add-mod.component';
import {
  LettereDiffidaEsitoSpedizioneUpdate
} from './components/fascicolo/lettere-diffida-update/lettere-diffida-esito-spedizione-update';
import {
  LettereDiffidaEsitoSpedizioneUpdateMod
} from './components/fascicolo/lettere-diffida-update/lettere-diffida-esito-spedizione-update-mod.component';
import {
  LettereDiffidaDatiGeneraliComponent
} from './components/fascicolo/lettere-diffida-update/lettere-diffida-dati-generali.component';
import {
  LettereDiffidaDatiGeneraliUpdateMod
} from './components/fascicolo/lettere-diffida-update/lettere-diffida-dati-generali-update-mod.component';
import {
  ParcellaStragiudizialeModAdd
} from './components/fascicolo/parcelle-stragiudiziali-add/parcella-stragiudiziale-mod-add';
import {
  ParcelleStragiudizialiAddComponent
} from './components/fascicolo/parcelle-stragiudiziali-add/parcelle-stragiudiziali-add.component';
import {
  ParcellaStragiudizialeModEdit
} from './components/fascicolo/parcelle-stragiudiziali-edit/parcella-stragiudiziale-mod-edit';
import {
  ParcelleStragiudizialiEditComponent
} from './components/fascicolo/parcelle-stragiudiziali-edit/parcelle-stragiudiziali-edit.component';
import {Pathbar} from './components/fascicolo/pathbar/pathbar';
import {
  ProvaScrittaMoldaUpdateComponent
} from './components/fascicolo/prove-scritte-update/prova-scritta-modal-update.component';
import {
  ProvaScrittaUpdateConcreteFormComponent
} from './components/fascicolo/prove-scritte-update/prova-scritta-update-concrete-form.component';
import {
  SezioneEconomicaAltriImportiEditComponent
} from './components/fascicolo/sezione-economica-altri-importi-edit/sezione-economica-altri-importi-edit.component';
import {
  SezioneEconomicaModAltriImportiEditComponent
} from './components/fascicolo/sezione-economica-altri-importi-edit/sezione-economica-mod-altri-importi-edit.component';
import {
  SezioneEconomicaCostiGestioneEditComponent
} from './components/fascicolo/sezione-economica-costi-gestione-edit/sezione-economica-costi-gestione-edit.component';
import {
  SezioneEconomicaModCostiGestioneEditComponent
} from './components/fascicolo/sezione-economica-costi-gestione-edit/sezione-economica-mod-costi-gestione-edit.component';
import {
  SezioneEconomicaDataInteressiEditComponent
} from './components/fascicolo/sezione-economica-data-interessi-edit/sezione-economica-data-interessi-edit.component';
import {
  SezioneEconomicaModDataInteressiEditComponent
} from './components/fascicolo/sezione-economica-data-interessi-edit/sezione-economica-mod-data-interessi-edit.component';
import {
  FondoRischiAddRevisioneComponent
} from './components/fascicolo/sezione-economica-fondo-rischi-add-revisione/sezione-economica-fondo-rischi-add-revisione.component';
import {
  ModFondoRischiAddRevisioneComponent
} from './components/fascicolo/sezione-economica-fondo-rischi-add-revisione/sezione-economica-mod-fondo-rischi-add-revisione.component';
import {
  FondoRischiEditRevisioneComponent
} from './components/fascicolo/sezione-economica-fondo-rischi-edit-revisione/sezione-economica-fondo-rischi-edit-revisione.component';
import {
  ModFondoRischiEditRevisioneComponent
} from './components/fascicolo/sezione-economica-fondo-rischi-edit-revisione/sezione-economica-mod-fondo-rischi-edit-revisione.component';
import {
  SezioneEconomicaLiquidatiAddComponent
} from './components/fascicolo/sezione-economica-liquidati-add/sezione-economica-liquidati-add.component';
import {
  SezioneEconomicaLiquidatiModAddComponent
} from './components/fascicolo/sezione-economica-liquidati-add/sezione-economica-mod-liquidati-add.component';
import {
  SezioneEconomicaLiquidatiUpdateComponent
} from './components/fascicolo/sezione-economica-liquidati-update/sezione-economica-liquidati-update.component';
import {
  SezioneEconomicaLiquidatiModUpdateComponent
} from './components/fascicolo/sezione-economica-liquidati-update/sezione-economica-mod-liquidati-update.component';
import {
  ModValoreEconomicoAddRevisioneComponent
} from './components/fascicolo/sezione-economica-valore-add-revisione/sezione-economica-mod-valore-add-revisione.component';
import {
  ValoreEconomicoAddRevisioneComponent
} from './components/fascicolo/sezione-economica-valore-add-revisione/sezione-economica-valore-add-revisione.component';
import {
  ModValoreEconomicoEditRevisioneComponent
} from './components/fascicolo/sezione-economica-valore-edit-revisione/sezione-economica-mod-valore-edit-revisione.component';
import {
  ValoreEconomicoEditRevisioneComponent
} from './components/fascicolo/sezione-economica-valore-edit-revisione/sezione-economica-valore-edit-revisione.component';
import {TitoloAddFormComponent} from './components/fascicolo/titoli-add/titolo-add-form.component';
import {TitoloModAddComponent} from './components/fascicolo/titoli-add/titolo-mod-add.component';
import {TitoloMoldaUpdateComponent} from './components/fascicolo/titoli-update/titolo-modal-update.component';
import {
  TitoloUpdateConcreteFormComponent
} from './components/fascicolo/titoli-update/titolo-update-concrete-form.component';
import {FooterFascicoloWizardComponent} from './components/footer-fascicolo-wizard/footer-fascicolo-wizard.component';
import {ConfermaCambioFrComponent} from './components/input-component/confermaCambioFR/conferma-cambio-fr.component';
import {
  InputNaturalNumberComponent
} from './components/input-component/inputNaturalNumber/input-natural-number.component';
import {RadioButtonComponent} from './components/input-component/radioButton/radio-button.component';
import {SearchPraticheComponent} from './components/input-component/searchPratiche/search-pratiche.component';
import {CopiaPraticaComponent} from './components/option-component/copiaPratica/copia-pratica.component';
import {CorrelaPraticaComponent} from './components/option-component/correlaPratica/correla-pratica.component';
import {
  DefinisciFascicoloConcreteFormComponent
} from './components/option-component/definisciFascicolo/definisci-fascicolo-concrete-form.component';
import {
  FascicoloDefinisciModal
} from './components/option-component/definisciFascicolo/definisci-fascicolo-modal.component';
import {OptionFascicoloComponent} from './components/option-component/optionFascicolo/option-fascicolo.component';
import {OptionPraticaComponent} from './components/option-component/optionPratica/option-pratica.component';
import {RiunisciGiudiziComponent} from './components/option-component/riunisciGiudizi/riunisci-giudizi.component';
import {ArchiviaModal} from './components/pratica/intestazione/archivia-modal';
import {
  IstanzaRisultatoPraticaComponent
} from './components/pratica/istanza-risultato-pratica/istanza-risultato-pratica.component';
import {RiunioneGiudiziEditComponent} from './components/pratica/pratiche-riunite/riunione-giudizi-edit.component';
import {RiunioneGiudiziModEdit} from './components/pratica/pratiche-riunite/riunione-giudizi-mod-edit';
import {
  AutorizzazioniViewComponent
} from './components/profili-utente/autorizzazioni-view/autorizzazioni-view.component';
import {
  TemplateUtenteAddComponent
} from './components/profili-utente/template-utente-add/template-utente-add.component';
import {
  TemplateUtenteModAddComponent
} from './components/profili-utente/template-utente-add/template-utente-mod-add.component';
import {
  TemplateUtenteModUpdateComponent
} from './components/profili-utente/template-utente-update/template-utente-mod-update.component';
import {
  TemplateUtenteUpdateComponent
} from './components/profili-utente/template-utente-update/template-utente-update.component';
import {UtenteAddComponent} from './components/profili-utente/utente-add/utente-add.component';
import {UtenteModAddComponent} from './components/profili-utente/utente-add/utente-mod-add.component';
import {UtenteModUpdateComponent} from './components/profili-utente/utente-update/utente-mod-update.component';
import {UtenteUpdateComponent} from './components/profili-utente/utente-update/utente-update.component';
import {SpinnerLoadComponent} from './components/spinner-load/spinner-load.component';
import {
  AddDocumentoToBeneImmobileComponent
} from './form/documento/add-to-beni-immobili/add-to-bene-immobile.component';
import {
  BeneImmobileEntityViewComponent
} from './form/documento/add-to-beni-immobili/bene-immobile-entity-view.component';
import {AddDocumentoToBeneMobileComponent} from './form/documento/add-to-beni-mobili/add-to-bene-mobile.component';
import {BeneMobileEntityViewComponent} from './form/documento/add-to-beni-mobili/bene-mobile-entity-view.component';
import {
  AddDocumentoToLetteraDiffidaComponent
} from './form/documento/add-to-lettera-diffida/add-to-lettera-diffida.component';
import {
  LetteraDiffidaEntityViewComponent
} from './form/documento/add-to-lettera-diffida/lettera-diffida-entity-view.component';
import {AddDocumentoToProvaScrittaComponent} from './form/documento/add-to-provascritta/add-to-provascritta.component';
import {ProvaScrittaEntityViewComponent} from './form/documento/add-to-provascritta/provascritta-entity-view.component';
import {
  AddDocumentoToTitoloEsecutivoComponent
} from './form/documento/add-to-titolo-esecutivo/add-to-titolo-esecutivo.component';
import {
  TitoloEsecutivoEntityViewComponent
} from './form/documento/add-to-titolo-esecutivo/titolo-esecutivo-entity-view.component';
import {
  ParcellaStragiudizialeQuadroPercentualeForm
} from './form/parcelle/stragiudiziali/parcella-stragiudiziale-quadro-percentuale-form';
import {
  ParcellaStragiudizialeQuadroTabellareForm
} from './form/parcelle/stragiudiziali/parcella-stragiudiziale-quadro-tabellare-form';
import {
  ParcellaStragiudizialeRiepilogoForm
} from './form/parcelle/stragiudiziali/parcella-stragiudiziale-riepilogo-form';
import {ValoreEconomicoRevisioneListComponent} from './form/sez-economica/valore-economico-revisione-list.component';
import {FondoRischiRevisioneListComponent} from './form/sez-economica/fondo-rischi-revisione-list.component';
import {CapitalizePipe} from './pipes/capitalize.pipe';
import {DateFormatterPipe} from './pipes/date-formatter.pipe';
import {CurrencyPipe} from './pipes/currency.pipe';
import {FilterRemovePipe} from './pipes/filter-remove.pipe';
import {FilterSearchPipe} from './pipes/filter-search.pipe';
import {FilterTermPipe} from './pipes/filter-term.pipe';
import {OrderByPipe} from './pipes/order-by.pipe';
import {PercentagePipe} from './pipes/percentage.pipe';
import {SanitizerUrlPipe} from './pipes/sanitizer_url.pipe.ts';
import {FormValidationService} from './services/form-validation.service';
import {IntestazioneFascicoloService} from './services/intestazione-fascicolo-service';
import {ObservableManager} from './utils/observable-manager';

import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {TagInputModule} from 'ngx-chips';
import {FilterItemMenuHidePipe} from './pipes/filter-item-menu-hide.pipe';
import {ScadenzaModAutoAddComponent} from './components/fascicolo/scadenzario-auto-add/scadenza-mod-auto-add.component';
import {
  ScadenzaAutoAddFormComponent
} from './components/fascicolo/scadenzario-auto-add/scadenza-auto-add-form.component';
import {
  EsitiModAutoAddScadenzeFormComponent
} from './components/fascicolo/esiti-auto-add-scadenze/esiti-mod-auto-add-scadenze-form.component';
import {
  EsitiModAutoAddScadenzeComponent
} from './components/fascicolo/esiti-auto-add-scadenze/esiti-mod-auto-add-scadenze.component';
import {NgSelectModule} from '@ng-select/ng-select';
import {NgSelectComboComponent} from './components/input-component/ng-select-combo/ng-select-combo.component';
import {FilterSearchPipeAmm} from './pipes/filter-search.pipe-amministrazione';
import {PaginationPipe} from './pipes/pagination.pipe';
import {PaginatorComponent} from './paginator/paginator.component';
import {MultiSelectComponent} from './components/input-component/multi-select/multiselect.component';
import {ListFilterPipe} from './components/input-component/multi-select/list-filter.pipe';
import {TitleAmiantoPipe} from './pipes/title-amianto.pipe';
import {ItemNewPraticaPipe} from './pipes/item-new-pratica.pipe';
import {
  PraticheCorrelateCreateComponent
} from './components/pratica/pratiche-correlate-create/pratiche-correlate-create.component';
import {ChackBoxRadioComponent} from './components/input-component/checkboxRadio/checkbox-radio.component';
import {ToggleSwitchComponent} from './components/input-component/toggle-switch/toggle-switch.component';
import {CreazioneRapidaComponent} from './components/pratica/creazione-rapida/creazione-rapida.component';
import {
  ContropartiPrecedentiAddComponent
} from './form/controparti-precedenti-add/controparti-precedenti-add.component';
import {
  PraticaCreateDatiClassificazioneDefaultComponent
} from './components/pratica/creazione/pratica-create-dati-classificazione-default/pratica-create-dati-classificazione-default.component';
import {PatologieModAggiungi} from './components/fascicolo/patologie-add/patologie-mod-aggiungi';
import {PatologiaEntityViewComponent} from './form/documento/add-to-patologia/patologia-entity-view.component';
import {AddDocumentoToPatologiaComponent} from './form/documento/add-to-patologia/add-to-patologia.component';
import {MultiFilterPipe} from './pipes/multi-filter.pipe';
import {
  DatiGeneraliAnagraficheComponent
} from './components/fascicolo/dati-generali-anagrafiche/dati-generali-anagrafiche.component';
import {AssociativaContropartiComponent} from './form/associativa-controparti/associativa-controparti.component';
import {
  DatiGeneraliAnagraficheSearchComponent
} from './components/fascicolo/dati-generali-anagrafiche-search/dati-generali-anagrafiche-search.component';
import {SpeseLegaliAddComponent} from './components/fascicolo/spese-legali-add/spese-legali-add.component';
import {SpeseLegaliModUpdate} from './components/fascicolo/spese-legali-update/spese-legali-mod-update';
import {
  SpeseLegaliFormUpdateComponent
} from './components/fascicolo/spese-legali-update/spese-legali-form-update.component';
import {SpeseLegaliFormAddComponent} from './components/fascicolo/spese-legali-update/spese-legali-form-add.component';
import {SchedeRecuperoModAggiungi} from './components/fascicolo/schede-recupero-add/schede-recupero-mod-aggiungi';
import {SchedeRecuperoComponent} from './components/fascicolo/schede-recupero-view/schede-recupero-component';
import {
  SchedaRecuperoEntityViewComponent
} from './form/documento/add-to-scheda-recupero/scheda-recupero-entity-view.component';
import {
  AddDocumentoToSchedaRecuperoComponent
} from './form/documento/add-to-scheda-recupero/add-to-scheda-recupero.component';
import {ValoreEconomicoViewComponent} from './form/sez-economica/valore-economico-view/valore-economico-view.component';
import {SchedeEsecuzioneModAggiungi} from './components/fascicolo/schede-esecuzione-add/schede-esecuzione-mod-aggiungi';
import {
  AddDocumentoToSchedaEsecuzioneComponent
} from './form/documento/add-to-scheda-esecuzione/add-to-scheda-esecuzione.component';
import {
  SchedaEsecuzioneEntityViewComponent
} from './form/documento/add-to-scheda-esecuzione/scheda-esecuzione-entity-view.component';
import {
  EsitiAddLiquidatiModComponent
} from './components/fascicolo/esiti-add-liquidati/esiti-add-liquidati-mod.component';
import {EsitiLiquidatiAddComponent} from './components/fascicolo/esiti-add-liquidati/esiti-add-liquidati.component';
import {IncassiRipartizioneComponent} from './components/fascicolo/incassi-ripartizione/incassi-ripartizione.component';
import {IncassoModRipartizione} from './components/fascicolo/incassi-ripartizione/incasso-mod-ripartizione';
import {FilterTenantItemPipe} from './pipes/filter-tenant-item.pipe';
import {ParcellaModRipartizione} from './components/fascicolo/parcelle-ripartizione/parcella-mod-ripartizione';
import {
  ParcelleRipartizioneComponent
} from './components/fascicolo/parcelle-ripartizione/parcella-ripartizione.component';
import {DocumentoSpostaCategoriaModal} from './components/documenti/documento-sposta/documento-sposta-modal.component';
import {
  LegaliDetaglioTariffaModalComponent
} from './components/fascicolo/legali-modifica-tariffa-modal/legali-modifica-tariffa-modal.component';
import {OptionsMenuComponent} from './components/options-menu/options-menu.component';
import {OfficeEditorComponent} from './components/office-editor/office-editor.component';
import {TreeviewComponentComponent} from './components/treeview-component/treeview-component.component';
import {
  DetailFolderFileComponent
} from './components/treeview-component/detail-folder-file/detail-folder-file.component';
import {DetailFolderFileOptionComponent} from './components/treeview-component/detail-folder-file-option/detail-folder-file-option.component';
import {
  OptionFileComponentComponent
} from './components/treeview-component/option-file-component/option-file-component.component';
import {
  OptionDirComponentComponent
} from './components/treeview-component/option-dir-component/option-dir-component.component';
import {InfoSocietaModalComponent} from './components/fascicolo/info-societa-modal/info-societa-modal.component';
import {UserService} from './services/user.service';
import {
  RicercaPrecedentiComponent
} from './components/option-component/ricerca-precedenti/ricerca-precedenti/ricerca-precedenti.component';
import {DatiGeneraliFascicoloCommonComponent} from './form/dati-generali-form/dati-generali-fascicolo-common.component';
import {
  DatiGeneraliFascicoloGiudizialeCommonComponent
} from './form/dati-generali-form/dati-generali-fascicolo-giudiziale-form/dati-generali-fascicolo-giudiziale-common.component';
import {SpeseGiudizioFormComponent} from './form/sez-economica/spese-giudizio-form/spese-giudizio-form.component';
import {CensimentoDocumentiFormComponent} from './form/censimento-documenti-form/censimento-documenti-form.component';
import {
  CensimentoDocumentiAddComponent
} from './components/fascicolo/censimento-documenti-add/censimento-documenti-add.component';
import {
  PersonalizzazioneDannoBiologicoViewComponent
} from './components/fascicolo/sezione-economica-danno-biologico/personalizzazione-danno-biologico-view/personalizzazione-danno-biologico-view.component';
import {
  PersonalizzazioneDannoBiologicoFormComponent
} from './components/fascicolo/sezione-economica-danno-biologico/personalizzazione-danno-biologico-form/personalizzazione-danno-biologico-form/personalizzazione-danno-biologico-form.component';
import {
  CensimentoDocumentiEditComponent
} from './components/fascicolo/censimento-documenti-edit/censimento-documenti-edit.component';
import {
  PersonalizzazioneDannoBiologicoEditModalComponent
} from './components/fascicolo/sezione-economica-danno-biologico/personalizzazione-danno-biologico-edit-modal/personalizzazione-danno-biologico-edit-modal/personalizzazione-danno-biologico-edit-modal.component';
import {
  ModContributoUnificatoAddComponent
} from './components/fascicolo/sezione-economica-contributo-unificato-add/sezione-economica-mod-add-contributo-unificato.component';
import {
  ModContributoUnificatoEditComponent
} from './components/fascicolo/sezione-economica-contributo-unificato-edit/sezione-economica-mod-edit-contributo-unificato.component';
import {
  ContributoUnificatoAddComponent
} from './components/fascicolo/sezione-economica-contributo-unificato-add/sezione-economica-contributo-unificato-add.component';
import {
  ContributoUnificatoEditComponent
} from './components/fascicolo/sezione-economica-contributo-unificato-edit/sezione-economica-contributo-unificato-edit.component';
import {
  OptionCensimentoDocumentiComponent
} from './components/option-component/option-censimento-documenti/option-censimento-documenti.component';
import {AvvisoParcellaRiepilogoForm} from './form/parcelle/stragiudiziali/avviso-parcella-riepilogo-form';
import {
  AvvisoParcellaEditComponent
} from './components/fascicolo/parcelle-stragiudiziali-edit/avviso-parcella-edit.component';
import {
  AvvisoParcellaAddComponent
} from './components/fascicolo/parcelle-stragiudiziali-add/avviso-parcelle-add.component';
import {FondoRischiViewComponent} from './form/sez-economica/fondo-rischi-view/fondo-rischi-view.component';
import {LiquidatiViewComponent} from './form/sez-economica/liquidati-view/liquidati-view.component';
import {
  DatiPignoramentoAddComponent
} from './components/fascicolo/dati-pignoramento-add/dati-pignoramento-add.component';
import {DatiPignoramentoModAdd} from './components/fascicolo/dati-pignoramento-add/dati-pignoramento-mod-add.component';
import {
  DatiPignoramentoUpdateComponent
} from './components/fascicolo/dati-pignoramento-update/dati-pignoramento-update.component';
import {
  DatiPignoramentoModUpdate
} from './components/fascicolo/dati-pignoramento-update/dati-pignoramento-mod-update.component';
import {
  AddDocumentoToDatiPignoramentoComponent
} from './form/documento/add-to-dati-pignoramento/add-to-dati-pignoramento.component';
import {
  DatiPignoramentoEntityViewComponent
} from './form/documento/add-to-dati-pignoramento/dati-pignoramento-entity-view.component';
import {
  ListaDocumentiTipoDocumentoComponent
} from './components/documenti/lista-documenti-tipo-documento/lista-documenti-tipo-documento.component';
import {
  Sole24OreComponent
} from './components/fascicolo/banche-dati-view/banche-dati-sole-24-ore/sole24-ore/sole24-ore.component';
import {
  DettaglioSole24OreComponent
} from './components/fascicolo/banche-dati-view/banche-dati-sole-24-ore/modale-dettaglio-sole-24-ore/dettaglio-sole24-ore.component';
import {PaginationComponent} from './pagination/pagination.component';
import {CustomDecimalPipePipe} from './pipes/custom-decimal-pipe.pipe';
import {ReplaceLineBreaks} from './pipes/replace-line-break.pipe';
import {BooleanTransformPipe} from './pipes/boolean-transform.pipe';
import {InsertionHostDirective} from './directives/insertion-host.directive';
import { PathbarLemComponent } from '../lem/utils/components/pathbar-lem/pathbar-lem.component';
import { SwitchComponent } from './components/input-component/switch/switch.component';
import { PickListComponent } from './components/input-component/pick-list/pick-list.component';
import { PickListModule } from 'primeng/picklist';
import { MetadataViewComponent } from './components/metadata/metadata-view/metadata-view.component';
import { ModalMetadataAddComponent  } from './components/metadata/modal-metadata-add/modal-metadata-add.component';
import { MetadataAddComponent } from './components/metadata/metadata-add/metadata-add.component';
import { PaginationDocumentComponent } from './pagination-document/pagination-document.component';
import { InputSwitchModule } from 'primeng/inputswitch';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputNumberModule } from 'primeng/inputnumber';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';
import { ChipModule } from 'primeng/chip';
import { ChipsModule } from 'primeng/chips';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { MultiSelectModule } from 'primeng/multiselect';
import { DynamicFormFieldComponent } from './components/dynamic-form-field/components/dynamic-form-light/components/dynamic-form-question/dynamic-form-field.component';
import { MetadataDynamicFormComponent } from './components/metadata-dynamic-form/metadata-dynamic-form/metadata-dynamic-form.component';
import { FascicoloMetadataFormComponent } from './components/metadata-dynamic-form/fascicolo-metadata-form/fascicolo-metadata-form.component';
import { PraticaMetadataFormComponent } from './components/metadata-dynamic-form/pratica-metadata-form/pratica-metadata-form.component';
import { MetadataDynamicViewComponent } from './components/metadata-dynamic-view/metadata-dynamic-view.component';
import {
 ProtocolFascicoloFormComponent
} from "././protocol/components/fascicolo/form/protocol-fascicolo-form.component";
import {
  ProtocolFascicoloDialogComponent
} from "./protocol/components/fascicolo/dialog/protocol-fascicolo-dialog.component";
import {
  ProtocolFascicoloSearchComponent
} from "././protocol/components/fascicolo/search/protocol-fascicolo-search.component";
import {ConfigurationService} from "./configuration/services/configuration.service";
import { DepotIframeComponent } from './components/option-component/depositoPct/depot-iframe/depot-iframe.component';
import { ProtocolFascicoloInsertComponent } from './protocol/components/fascicolo/insert/protocol-fascicolo-insert.component';
import { ProtocollaDocumentoModalComponent } from './components/documenti/protocolla-documento/protocolla-documento-modal.component';
import {SignDocumentFormComponent} from "./sign/document/components/form/sign-document-form.component";
import {SignDocumentService} from "./sign/document/services/sign-document.service";
import {SignDocumentDialogComponent} from "./sign/document/components/dialog/sign-document-dialog.component";
import {SignDocumentOtpComponent} from "./sign/document/components/otp/sign-document-otp.component";
import { UploadToolComponent } from '../core/components/upload-tool/upload-tool.component';
import { PraticaModule } from '../pratica/pratica.module';
import { CreazionePraticaStepperComponent } from './creazione-rapida/wizard-creazione/components/creazione-pratica-stepper/creazione-pratica-stepper.component';
import { StepDatiGenPraticaComponent } from './creazione-rapida/wizard-creazione/components/step-dati-gen-pratica/step-dati-gen-pratica.component';
import { ClassificazioneFormComponent } from './creazione-rapida/wizard-creazione/components/step-dati-gen-pratica/components/classificazione-form/classificazione-form.component';
import { ClassificazioniComponent } from './creazione-rapida/wizard-creazione/components/step-dati-gen-pratica/components/classificazioni/classificazioni.component';
import { DatiGenPraticaFormComponent } from './creazione-rapida/wizard-creazione/components/step-dati-gen-pratica/components/dati-gen-pratica-form/dati-gen-pratica-form.component';
import { TipoPraticaWidgetComponent } from './creazione-rapida/wizard-creazione/components/step-dati-gen-pratica/components/tipo-pratica-widget/tipo-pratica-widget.component';
import { StepPartiComponent } from './creazione-rapida/wizard-creazione/components/step-parti/step-parti.component';
import { StepSoggettiTerziComponent } from './creazione-rapida/wizard-creazione/components/step-soggetti-terzi/step-soggetti-terzi.component';
import { StepDatiEconomiciComponent } from './creazione-rapida/wizard-creazione/components/step-dati-economici/step-dati-economici.component';
import { PetitumFormComponent } from './creazione-rapida/wizard-creazione/components/step-dati-economici/components/petitum-form/petitum-form.component';
import { StepAttiComponent } from './creazione-rapida/wizard-creazione/components/step-atti/step-atti.component';
import { StepAdempimentiFormComponent } from './creazione-rapida/wizard-creazione/components/step-adempimenti/components/form/step-adempimenti-form.component';
import { StepAdempimentiListComponent } from './creazione-rapida/wizard-creazione/components/step-adempimenti/components/list/step-adempimenti-list.component';
import { StepAdempimentiComponent } from './creazione-rapida/wizard-creazione/components/step-adempimenti/step-adempimenti.component';
import { StepDocumentazioneAllegataComponent } from './creazione-rapida/wizard-creazione/components/step-documentazione-allegata/step-documentazione-allegata.component';
import { StepAttiFormComponent } from './creazione-rapida/wizard-creazione/components/step-atti/step-atti-form/step-atti-form.component';
import { StepSoggettiTerziListComponent } from './creazione-rapida/wizard-creazione/components/step-soggetti-terzi/components/soggetto-list/step-soggetti-terzi-list.component';
import { StepSoggettiTerziFormComponent } from './creazione-rapida/wizard-creazione/components/step-soggetti-terzi/components/form/step-soggetti-terzi-form.component';
import { ListPartiComponent } from './creazione-rapida/wizard-creazione/components/step-parti/list-parti/list-parti.component';
import { AnagraficaParteFormComponent } from './creazione-rapida/wizard-creazione/components/step-parti/anagrafica-parte-form/anagrafica-parte-form.component';
import { AssociazioneControparteFormComponent } from './creazione-rapida/wizard-creazione/components/step-parti/associazione-controparte-form/associazione-controparte-form.component';
import { ListContropartiComponent } from './creazione-rapida/wizard-creazione/components/step-parti/list-controparti/list-controparti.component';
import { AddFolderFormComponent } from './creazione-rapida/wizard-creazione/components/step-documentazione-allegata/components/add-folder-form/add-folder-form.component';
import { NewDocumentFormComponent } from './creazione-rapida/wizard-creazione/components/step-documentazione-allegata/components/new-document-form/new-document-form.component';
import { StepSoggettiTerziFormAssociativaComponent } from './creazione-rapida/wizard-creazione/components/step-soggetti-terzi/components/form/form-associativa/step-soggetti-terzi-form-associativa.component';
import { StepSoggettiTerziListAltrepartiComponent } from './creazione-rapida/wizard-creazione/components/step-soggetti-terzi/components/step-soggetti-terzi-list-altreparti/step-soggetti-terzi-list-altreparti.component';
import { StepPartiFormInserimentoComponent } from './creazione-rapida/wizard-creazione/components/step-parti/step-parti-form-inserimento/step-parti-form-inserimento.component';
import { AttiListViewComponent } from './creazione-rapida/wizard-creazione/components/step-atti/atti-list-view/atti-list-view.component';
import { StepDatiGenFascicoloComponent } from './creazione-rapida/wizard-creazione/components/step-dati-gen-fascicolo/step-dati-gen-fascicolo.component';
import { TipoPraticaPipe } from './pipes/tipo-pratica.pipe';
import { TooltipDirective } from './directives/tooltip.directive';
import { DropdownModule } from 'primeng/dropdown';
import { RicercaPrecedentiCoreComponent } from './components/option-component/ricerca-precedenti/ricerca-precedenti-core/ricerca-precedenti-core.component';
import { CalendarModule } from 'primeng/calendar';
import { MillisecondsToDatePipe } from './pipes/milliseconds-to-date.pipe';
import { ReatiAddComponent } from './components/fascicolo/reati-add/reati-add.component';
import { ReatoModAdd } from './components/fascicolo/reati-add/reato-mod-add';
import { ReatoModEdit } from './components/fascicolo/reati-edit/reato-mod-edit';
import { ReatiEditComponent } from './components/fascicolo/reati-edit/reati-edit.component';

import { FilterDocumentTypePipe } from './protocol/components/fascicolo/insert/filter-document-type.pipe';
import { ProtocolDocumentSelectionComponent } from './protocol/components/protocol-document-selection/protocol-document-selection.component';
import { MultiKeyFilterPipe } from './protocol/components/protocol-document-selection/multi-key-filter.pipe';
import { MarkDocumentFormComponent } from './mark/document/components/form/mark-document-form.component';
import { MarkDocumentDialogComponent } from './mark/document/components/dialog/mark-document-dialog.component';
import { MarkDocumentService } from './mark/document/services/mark-document.service';
import { ScadenzaEvadiComponent } from './components/fascicolo/scadenza-evadi/scadenza-evadi.component';
import { DettaglioAdempimentoComponent } from './components/fascicolo/dettaglio-adempimenti/dettaglio-adempimento.component';
import { DettaglioAdempimentoMod } from './components/fascicolo/dettaglio-adempimenti/dettaglio-adempimento-mod';
import { ViewDocumentDialogComponent } from './components/view-document-dialog/view-document-dialog.component';
import { EmlPreviewComponent } from './components/file-preview/eml/eml-preview.component';
import { ZipPreviewComponent } from './components/file-preview/zip/zip-preview.component';
// import { PdfPreviewComponent } from './components/file-preview/pdf/pdf-preview.component';
import { PdfReaderComponent } from './components/file-preview/pdf-reader/pdf-reader.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { InviaNotificaModalComponent } from './components/option-component/inviaNotifica/invia-notifica-modal.component';
import { NgxPrintDirective } from './directives/ngx-print.directive';
import { AssociativaSoggettiTerziComponent } from './form/associativa-soggetti-terzi/associativa-soggetti-terzi.component';
import { SelezioneFascicoliSecondariComponent } from './protocol/components/fascicolo/dialog/selezione-fascicoli-secondari/selezione-fascicoli-secondari.component';
import { CleanInputDirective } from './directives/clean-input.directive';
import { DropdownFocusDirective } from './directives/focusout-options.directive';
import { AnnullaDocumentoProtocolloComponent } from './protocol/components/fascicolo/dialog/annulla-documento-protocollo/annulla-documento-protocollo.component';
import { DocumentUploadedComponent } from './form/documento/document-uploaded/document-uploaded.component';
import { DetailTableComponent } from './form/documento/document-uploaded/detail-table/detail-table.component';
import { UpdateMetadatiComponent } from './components/fascicolo/documentazione-allegata-view/metadati/update-metadati/update-metadati.component';
import { MetadatoDocumentoFormComponent } from './components/fascicolo/documentazione-allegata-view/metadati/update-metadati/metadato-documento-form/metadato-documento-form.component';
import { UpdateMetadatiConservazioneComponent } from './components/fascicolo/update-metadati-conservazione/update-metadati-conservazione.component';
import { GestioneMetadatiFascicoloComponent } from './components/option-component/gestione-metadati/gestione-metadati-fascicolo.component';
import { DocumentoDettaglioMetadatoModalComponent } from './components/option-component/documentoDettaglioModal/documento-dettaglio-metadato-modal.component';
import { UnderscoreToSpacePipe } from './pipes/underscore-to-space.pipe';
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    TagInputModule,
    NgSelectModule,
    PickListModule,
    InputSwitchModule,
    RadioButtonModule,
    InputNumberModule,
    CheckboxModule,
    InputTextModule,
    TooltipModule,
    ChipModule,
    InputTextareaModule,
    MultiSelectModule,
    ChipsModule,
    DropdownModule,
    UploadToolComponent,
    CalendarModule,
    PdfViewerModule
  ],
  declarations: [
    DropdownFocusDirective,
    CreazionePraticaStepperComponent,
    StepDatiGenPraticaComponent,
    ClassificazioneFormComponent,
    ClassificazioniComponent,
    DatiGenPraticaFormComponent,
    TipoPraticaWidgetComponent,
    StepPartiComponent,
    StepSoggettiTerziComponent,
    StepDatiEconomiciComponent,
    PetitumFormComponent,
    StepAttiComponent,
    StepAdempimentiFormComponent,
    StepAdempimentiListComponent,
    StepAdempimentiComponent,
    StepDocumentazioneAllegataComponent,
    StepAttiFormComponent,
    StepSoggettiTerziListComponent,
    StepSoggettiTerziFormComponent,
    ListPartiComponent,
    AnagraficaParteFormComponent,
    AssociazioneControparteFormComponent,
    ListContropartiComponent,
    AddFolderFormComponent,
    NewDocumentFormComponent,
    StepSoggettiTerziFormAssociativaComponent,
    StepSoggettiTerziListAltrepartiComponent,
    StepPartiFormInserimentoComponent,
    AttiListViewComponent,
    StepDatiGenFascicoloComponent,

    BaseForm,
    IntestazioneComponent,
    EsitiMeritoUpdateMod,
    EsitiMeritoAddComponent,
    IntestazionePraticaComponent,
    CheckBoxModComponent,
    ChackBoxRadioComponent,
    ToggleSwitchComponent,
    CheckListComponent,
    ComboModComponent,
    NgSelectComboComponent,
    DatePickerComponent,
    InputTextComponent,
    InputNaturalNumberComponent,
    OraComboComponent,
    TextAreaComponent,
    RadioButtonComponent,
    FilterSearchPipe,
    SubmitButtonComponent,
    SpinnerComponent,
    FilterTermPipe,
    OrderByPipe,
    MultiFilterPipe,
    PercentagePipe,
    CurrencyPipe,
    CapitalizePipe,
    DateFormatterPipe,
    FilterRemovePipe,
    FilterSearchPipeAmm,
    ListaDocumentiComponent,
    LegaleAnagraficaUpdate,
    LegaliModAnagraficaUdate,
    LegaliAssociativaUpdateComponent,
    LegaliModAssociativaUdate,
    ParteAnagraficaUpdateComponent,
    ParteModAnagraficaUdate,
    AltrePartiUpdateAssociativaComponent,
    AltrePartiModAssociativaUpdate,
    ScadenzaModModifyComponent,
    ScadenzaUpdateConcreteFormComponent,
    ScadenzaModRinvioComponent,
    ScadenzaRinvioConcreteFormComponent,
    ScadenzaListRinviiConcreteFormComponent,
    ScadenzaModListRinviiComponent,
    FatturaRiepilogoForm,
    FattureEditComponent,
    PagamentiEditComponent,
    IncassiEditComponent,
    InputTextReadOnlyComponent,
    ContropartiModAssociativaUpdate,
    ContropartiAssociativaUpdateComponent,
    InputTextCurrencyComponent,
    EsitiDatiGeneraliUpdateMod,
    EsitiDatiGeneraliComponent,
    FileInputComponent,
    ParteAnagraficaAddComponent,
    ContropartiModAggiungi,
    ContropartiAssociativaAddComponent,
    DocumentVersionHistoryModal,
    DocumentVersionHistoryComponent,
    DocumentVersionUpdateModal,
    FatturaModAdd,
    FattureAddComponent,
    FatturaModEdit,
    IncassiAddComponent,
    IncassoModAdd,
    IncassoModRipartizione,
    IncassiRipartizioneComponent,
    DettaglioAdempimentoMod,
    DettaglioAdempimentoComponent,
    IncassoModEdit,
    PagamentiAddComponent,
    PagamentoModAdd,
    PagamentoModEdit,
    ReatiAddComponent,
    ReatiEditComponent,
    ReatoModAdd,
    ReatoModEdit,
    AltrePartiAssociativaAddComponent,
    AltrePartiModAggiungi,
    PagamentoModEdit,
    ParcellaGiudizialeRiepilogoForm,
    ParcelleGiudizialiEditComponent,
    ParcellaGiudizialeModEdit,
    ParcelleGiudizialiAddComponent,
    ParcellaGiudizialeModAdd,
    ParcellaGiudizialeQuadroForm,
    ParcellaStragiudizialeRiepilogoForm,
    AvvisoParcellaRiepilogoForm,
    ParcelleStragiudizialiEditComponent,
    AvvisoParcellaEditComponent,
    ParcellaStragiudizialeModEdit,
    ParcelleStragiudizialiAddComponent,
    AvvisoParcellaAddComponent,
    ParcellaStragiudizialeModAdd,
    ParcellaStragiudizialeQuadroTabellareForm,
    ParcellaStragiudizialeQuadroPercentualeForm,
    ParcellaModRipartizione,
    ParcelleRipartizioneComponent,
    LegaleAnagraficaAddComponent,
    LegaliModAggiungi,
    SchedeRecuperoModAggiungi,
    SchedeEsecuzioneModAggiungi,
    AttiModAdd,
    AttiModModify,
    AttiAddConcreteFormComponent,
    AttiModifyConcreteFormComponent,
    LegaliAssociativaAddComponent,
    SearchTextComponent,
    SearchPraticheComponent,
    ListaDocumentiDiSezioneComponent,
    RicercaAnagraficheFormComponent,
    SezioneEconomicaFondoOneriModUpdateComponent,
    SezioneEconomicaFondoOneriUpdateComponent,
    SezioneEconomicaFondoOneriModAddComponent,
    SezioneEconomicaFondoOneriAddComponent,
    SezioneEconomicaLiquidatiModUpdateComponent,
    SezioneEconomicaLiquidatiUpdateComponent,
    SezioneEconomicaLiquidatiAddComponent,
    SezioneEconomicaLiquidatiModAddComponent,
    SezioneEconomicaModDataInteressiEditComponent,
    SezioneEconomicaDataInteressiEditComponent,
    SezioneEconomicaModAltriImportiEditComponent,
    SezioneEconomicaAltriImportiEditComponent,
    SezioneEconomicaModCostiGestioneEditComponent,
    SezioneEconomicaCostiGestioneEditComponent,
    ModContributoUnificatoAddComponent,
    ModContributoUnificatoEditComponent,
    ContributoUnificatoAddComponent,
    ContributoUnificatoEditComponent,
    ModValoreEconomicoAddRevisioneComponent,
    ValoreEconomicoAddRevisioneComponent,
    ModValoreEconomicoEditRevisioneComponent,
    ValoreEconomicoEditRevisioneComponent,
    ModFondoRischiAddRevisioneComponent,
    FondoRischiAddRevisioneComponent,
    ModFondoRischiEditRevisioneComponent,
    FondoRischiEditRevisioneComponent,
    ValoreEconomicoRevisioneListComponent,
    FondoRischiRevisioneListComponent,
    DocumentoAddModal,
    DocumentoSpostaCategoriaModal,
    DocumentoAddForm,
    ScadenzaAddConcreteFormComponent,
    ScadenzaModAddComponent,
    ScadenzaModAutoAddComponent,
    ScadenzaAutoAddFormComponent,
    EsitiModAutoAddScadenzeFormComponent,
    EsitiModAutoAddScadenzeComponent,
    EsitiAddMod,
    EsitiAddComponent,
    FascicoloSelectModal,
    DefinisciFascicoloConcreteFormComponent,
    DepositoPctComponent,
    FascicoloDefinisciModal,
    ContropartiAnagraficaViewComponent,
    AddDocumentoToControparteComponent,
    AddDocumentoToAltraParteComponent,
    AltrePartiAnagraficaViewComponent,
    AddDocumentoToLegaleComponent,
    LegaleAnagraficaViewComponent,
    AddDocumentoToScadenzaComponent,
    AddDocumentoToAttoComponent,
    AddDocumentoToSchedaRecuperoComponent,
    AddDocumentoToSchedaEsecuzioneComponent,
    ClassificazionePraticaComponent,
    ClassificazionePraticaUpdateComponent,
    ClassificazioneModUpdateComponent,
    ClassificazionePraticaAddComponent,
    ClassificazioneModAddComponent,
    AddDocumentoToEsitoComponent,
    ControparteEntityViewComponent,
    SchedaRecuperoEntityViewComponent,
    SchedaEsecuzioneEntityViewComponent,
    EsitoEntityViewComponent,
    LegaleIncaricatoEntityViewComponent,
    ScadenzaEntityViewComponent,
    AttoEntityViewComponent,
    AddDocumentoToPagamentoComponent,
    PagamentoEntityViewComponent,
    AddDocumentoToFatturaComponent,
    IncassoEntityViewComponent,
    AddDocumentoToIncassoComponent,
    AddDocumentoToParcellaComponent,
    ParcellaEntityViewComponent,
    FatturaEntityViewComponent,
    DocumentUpdateMetadatiModal,
    DocumentUpdateMetadatiFormComponent,
    DocumentVersionUpdateFormComponent,
    DefineFascicoloComponent,
    DeletePraticaComponent,
    EsitiMeritoAddMod,
    EsitiMeritoUpdate,
    BeniImmobiliModAddComponent,
    BeniImmobiliModUpdateComponent,
    BeniImmobiliAddComponent,
    BeniImmobiliUpdateComponent,
    LettereDiffidaAddComponent,
    LettereDiffidaAddMod,
    LettereDiffidaEsitoSpedizioneAddComponent,
    LettereDiffidaEsitoSpedizioneAddMod,
    LettereDiffidaEsitoSpedizioneUpdate,
    LettereDiffidaEsitoSpedizioneUpdateMod,
    LettereDiffidaDatiGeneraliComponent,
    LettereDiffidaDatiGeneraliUpdateMod,
    AddDocumentoToLetteraDiffidaComponent,
    LetteraDiffidaEntityViewComponent,
    ProvaScrittaModAddComponent,
    ProveScritteAddFormComponent,
    BeniMobiliAddComponent,
    BeniMobiliModAdd,
    ProveScritteAddFormComponent,
    ProvaScrittaUpdateConcreteFormComponent,
    ProvaScrittaMoldaUpdateComponent,
    TitoloModAddComponent,
    TitoloAddFormComponent,
    AddDocumentoToProvaScrittaComponent,
    ProvaScrittaEntityViewComponent,
    TitoloMoldaUpdateComponent,
    TitoloUpdateConcreteFormComponent,
    BeniMobiliUpdateComponent,
    BeniMobiliModUpdate,
    AddDocumentoToTitoloEsecutivoComponent,
    TitoloEsecutivoEntityViewComponent,
    BeneImmobileEntityViewComponent,
    AddDocumentoToBeneImmobileComponent,
    AddDocumentoToBeneMobileComponent,
    BeneMobileEntityViewComponent,
    CorrelaPraticaComponent,
    CopiaPraticaComponent,
    AssegnazioneCompetenzaFormComponent,
    AssegnatariModalComponent,
    RifiutoComponent,
    FooterFascicoloWizardComponent,
    IstanzaRisultatoPraticaComponent,
    RiunisciGiudiziComponent,
    Pathbar,
    PathbarLemComponent,
    ExportHelpComponent,
    SpinnerLoadComponent,
    ArchiviaModal,
    AutorizzazioniViewComponent,
    TemplateUtenteUpdateComponent,
    TemplateUtenteModUpdateComponent,
    TemplateUtenteAddComponent,
    TemplateUtenteModAddComponent,
    UtenteUpdateComponent,
    UtenteModUpdateComponent,
    UtenteAddComponent,
    UtenteModAddComponent,
    RiunioneGiudiziModEdit,
    RiunioneGiudiziEditComponent,
    OptionFascicoloComponent,
    OptionPraticaComponent,
    OptionCensimentoDocumentiComponent,
    ConfermaCambioFrComponent,
    SanitizerUrlPipe,
    DatiFascicoloComponent,
    FilterItemMenuHidePipe,
    PaginationPipe,
    ListFilterPipe,
    PaginatorComponent,
    CreazioneRapidaComponent,
    MultiSelectComponent,
    TitleAmiantoPipe,
    UnderscoreToSpacePipe,
    ItemNewPraticaPipe,
    PraticheCorrelateCreateComponent,
    ContropartiPrecedentiAddComponent,
    PraticaCreateDatiClassificazioneDefaultComponent,
    PatologieModAggiungi,
    PatologiaEntityViewComponent,
    AddDocumentoToPatologiaComponent,
    DatiGeneraliAnagraficheComponent,
    AssociativaContropartiComponent,
    AssociativaSoggettiTerziComponent,
    DatiGeneraliAnagraficheSearchComponent,
    SpeseLegaliAddComponent,
    SpeseLegaliModUpdate,
    SpeseLegaliFormUpdateComponent,
    SpeseLegaliFormAddComponent,
    ValoreEconomicoViewComponent,
    FondoRischiViewComponent,
    LiquidatiViewComponent,
    EsitiLiquidatiAddComponent,
    EsitiAddLiquidatiModComponent,
    FilterTenantItemPipe,
    LegaliDetaglioTariffaModalComponent,
    OptionsMenuComponent,
    OfficeEditorComponent,
    TreeviewComponentComponent,
    DetailFolderFileComponent,
    DetailFolderFileOptionComponent,
    CensimentoDocumentiFormComponent,
    CensimentoDocumentiAddComponent,
    CensimentoDocumentiEditComponent,
    PersonalizzazioneDannoBiologicoViewComponent,
    PersonalizzazioneDannoBiologicoEditModalComponent,
    PersonalizzazioneDannoBiologicoFormComponent,
    OptionFileComponentComponent,
    OptionDirComponentComponent,
    InfoSocietaModalComponent,
    RicercaPrecedentiComponent,
    DatiGeneraliFascicoloCommonComponent,
    DatiGeneraliFascicoloGiudizialeCommonComponent,
    SpeseGiudizioFormComponent,
    DatiPignoramentoAddComponent,
    DatiPignoramentoModAdd,
    DatiPignoramentoUpdateComponent,
    DatiPignoramentoModUpdate,
    DatiPignoramentoEntityViewComponent,
    AddDocumentoToDatiPignoramentoComponent,
    ListaDocumentiTipoDocumentoComponent,
    Sole24OreComponent,
    DettaglioSole24OreComponent,
    PaginationComponent,
    CustomDecimalPipePipe,
    ReplaceLineBreaks,
    BooleanTransformPipe,
    TipoPraticaPipe,
    InsertionHostDirective,
    SwitchComponent,
    PickListComponent,
    MetadataViewComponent,
    ModalMetadataAddComponent,
    MetadataAddComponent,
    PaginationDocumentComponent,
    DynamicFormFieldComponent,
    MetadataDynamicFormComponent,
    FascicoloMetadataFormComponent,
    PraticaMetadataFormComponent,
    MetadataDynamicViewComponent,
    ProtocolFascicoloFormComponent,
    ProtocolFascicoloDialogComponent,
    ProtocolFascicoloSearchComponent,
    ProtocolFascicoloInsertComponent,
    DepotIframeComponent,
    ProtocollaDocumentoModalComponent,
    SignDocumentFormComponent,
    SignDocumentDialogComponent,
    MarkDocumentFormComponent,
    MarkDocumentDialogComponent,
    SignDocumentOtpComponent,
    TooltipDirective,
    CleanInputDirective,
    NgxPrintDirective,
    RicercaPrecedentiCoreComponent,
    MillisecondsToDatePipe,
    FilterDocumentTypePipe,
    ProtocolDocumentSelectionComponent,
    MultiKeyFilterPipe,
    ScadenzaEvadiComponent,
    ViewDocumentDialogComponent,
    EmlPreviewComponent,
    ZipPreviewComponent,
    // PdfPreviewComponent,
    PdfReaderComponent,
    InviaNotificaModalComponent,
    SelezioneFascicoliSecondariComponent,
    AnnullaDocumentoProtocolloComponent,
    DocumentUploadedComponent,
    DetailTableComponent,
    UpdateMetadatiComponent,
    MetadatoDocumentoFormComponent,
    UpdateMetadatiConservazioneComponent,
    GestioneMetadatiFascicoloComponent,
    DocumentoDettaglioMetadatoModalComponent,
  ],
  providers: [
    ListFilterPipe,
    MultiSelectComponent,
    FormValidationService,
    ServicesSearch,
    ObservableManager,
    IntestazioneFascicoloService,
    FilterSearchPipe,
    FilterTermPipe,
    FilterItemMenuHidePipe,
    TitleAmiantoPipe,
    UnderscoreToSpacePipe,
    ItemNewPraticaPipe,
    FilterTenantItemPipe,
    UserService,
    ConfigurationService,
    SignDocumentService,
    MarkDocumentService,
    TipoPraticaPipe
  ],
  exports: [
    BaseForm,
    IntestazioneComponent,
    EsitiMeritoUpdateMod,
    EsitiMeritoAddComponent,
    IntestazionePraticaComponent,
    CheckBoxModComponent,
    ChackBoxRadioComponent,
    ToggleSwitchComponent,
    CheckListComponent,
    RicercaPrecedentiComponent,
    RicercaPrecedentiCoreComponent,
    ComboModComponent,
    NgSelectComboComponent,
    DatePickerComponent,
    InputTextComponent,
    InputNaturalNumberComponent,
    RadioButtonComponent,
    OraComboComponent,
    TextAreaComponent,
    SubmitButtonComponent,
    SpinnerComponent,
    FilterSearchPipe,
    DateFormatterPipe,
    FilterTermPipe,
    OrderByPipe,
    PercentagePipe,
    CurrencyPipe,
    CapitalizePipe,
    FilterRemovePipe,
    ListaDocumentiComponent,
    LegaleAnagraficaUpdate,
    LegaliModAnagraficaUdate,
    LegaliAssociativaUpdateComponent,
    LegaliModAssociativaUdate,
    ParteAnagraficaUpdateComponent,
    ParteModAnagraficaUdate,
    AltrePartiUpdateAssociativaComponent,
    AltrePartiModAssociativaUpdate,
    ScadenzaModModifyComponent,
    ScadenzaUpdateConcreteFormComponent,
    ScadenzaModRinvioComponent,
    ScadenzaRinvioConcreteFormComponent,
    ScadenzaListRinviiConcreteFormComponent,
    ScadenzaModListRinviiComponent,
    FatturaRiepilogoForm,
    FattureEditComponent,
    PagamentiEditComponent,
    IncassiEditComponent,
    InputTextReadOnlyComponent,
    ContropartiModAssociativaUpdate,
    ContropartiAssociativaUpdateComponent,
    InputTextCurrencyComponent,
    EsitiDatiGeneraliUpdateMod,
    EsitiDatiGeneraliComponent,
    EsitiLiquidatiAddComponent,
    EsitiAddLiquidatiModComponent,
    FileInputComponent,
    ParteAnagraficaAddComponent,
    ContropartiModAggiungi,
    ContropartiAssociativaAddComponent,
    DocumentVersionHistoryModal,
    DocumentVersionHistoryComponent,
    DocumentVersionUpdateModal,
    FatturaModAdd,
    FattureAddComponent,
    FatturaModEdit,
    IncassiAddComponent,
    IncassoModAdd,
    IncassoModRipartizione,
    IncassiRipartizioneComponent,
    DettaglioAdempimentoMod,
    DettaglioAdempimentoComponent,
    IncassoModEdit,
    PagamentiAddComponent,
    PagamentoModAdd,
    PagamentoModEdit,
    ReatiAddComponent,
    ReatiEditComponent,
    ReatoModAdd,
    ReatoModEdit,
    AltrePartiAssociativaAddComponent,
    AltrePartiModAggiungi,
    PagamentoModEdit,
    SchedeRecuperoModAggiungi,
    SchedeEsecuzioneModAggiungi,
    ParcellaGiudizialeRiepilogoForm,
    ParcelleGiudizialiEditComponent,
    ParcellaGiudizialeModEdit,
    ParcelleGiudizialiAddComponent,
    ParcellaGiudizialeModAdd,
    ParcellaGiudizialeQuadroForm,
    ParcellaStragiudizialeRiepilogoForm,
    AvvisoParcellaRiepilogoForm,
    ParcelleStragiudizialiEditComponent,
    AvvisoParcellaEditComponent,
    ParcellaStragiudizialeModEdit,
    ParcelleStragiudizialiAddComponent,
    AvvisoParcellaAddComponent,
    ParcellaStragiudizialeModAdd,
    ParcellaStragiudizialeQuadroTabellareForm,
    ParcellaStragiudizialeQuadroPercentualeForm,
    ParcellaModRipartizione,
    ParcelleRipartizioneComponent,
    LegaleAnagraficaAddComponent,
    LegaliModAggiungi,
    AttiModAdd,
    AttiModModify,
    AttiAddConcreteFormComponent,
    AttiModifyConcreteFormComponent,
    LegaliAssociativaAddComponent,
    SearchTextComponent,
    SearchPraticheComponent,
    ListaDocumentiDiSezioneComponent,
    RicercaAnagraficheFormComponent,
    SezioneEconomicaFondoOneriModUpdateComponent,
    SezioneEconomicaFondoOneriUpdateComponent,
    SezioneEconomicaFondoOneriModAddComponent,
    SezioneEconomicaFondoOneriAddComponent,
    SezioneEconomicaLiquidatiModUpdateComponent,
    SezioneEconomicaLiquidatiUpdateComponent,
    SezioneEconomicaLiquidatiAddComponent,
    SezioneEconomicaLiquidatiModAddComponent,
    SezioneEconomicaModDataInteressiEditComponent,
    SezioneEconomicaDataInteressiEditComponent,
    SezioneEconomicaModAltriImportiEditComponent,
    SezioneEconomicaAltriImportiEditComponent,
    SezioneEconomicaModCostiGestioneEditComponent,
    SezioneEconomicaCostiGestioneEditComponent,
    ModContributoUnificatoAddComponent,
    ModContributoUnificatoEditComponent,
    ContributoUnificatoAddComponent,
    ContributoUnificatoEditComponent,
    ModValoreEconomicoAddRevisioneComponent,
    ValoreEconomicoAddRevisioneComponent,
    ModValoreEconomicoEditRevisioneComponent,
    ValoreEconomicoEditRevisioneComponent,
    ModFondoRischiAddRevisioneComponent,
    FondoRischiAddRevisioneComponent,
    ModFondoRischiEditRevisioneComponent,
    FondoRischiEditRevisioneComponent,
    ValoreEconomicoRevisioneListComponent,
    FondoRischiRevisioneListComponent,
    DocumentoAddModal,
    DocumentoSpostaCategoriaModal,
    DocumentoAddForm,
    ScadenzaAddConcreteFormComponent,
    ScadenzaModAddComponent,
    ScadenzaModAutoAddComponent,
    EsitiModAutoAddScadenzeComponent,
    ContropartiAnagraficaViewComponent,
    EsitiAddMod,
    EsitiAddComponent,
    FascicoloSelectModal,
    DefinisciFascicoloConcreteFormComponent,
    DepositoPctComponent,
    FascicoloDefinisciModal,
    AddDocumentoToControparteComponent,
    AddDocumentoToAltraParteComponent,
    AltrePartiAnagraficaViewComponent,
    AddDocumentoToLegaleComponent,
    LegaleAnagraficaViewComponent,
    AddDocumentoToScadenzaComponent,
    AddDocumentoToAttoComponent,
    AddDocumentoToSchedaRecuperoComponent,
    AddDocumentoToSchedaEsecuzioneComponent,
    ClassificazionePraticaComponent,
    ClassificazionePraticaUpdateComponent,
    ClassificazioneModUpdateComponent,
    ClassificazionePraticaAddComponent,
    ClassificazioneModAddComponent,
    AddDocumentoToEsitoComponent,
    ControparteEntityViewComponent,
    SchedaRecuperoEntityViewComponent,
    SchedaEsecuzioneEntityViewComponent,
    EsitoEntityViewComponent,
    LegaleIncaricatoEntityViewComponent,
    ScadenzaEntityViewComponent,
    AttoEntityViewComponent,
    AddDocumentoToPagamentoComponent,
    PagamentoEntityViewComponent,
    AddDocumentoToFatturaComponent,
    IncassoEntityViewComponent,
    AddDocumentoToIncassoComponent,
    AddDocumentoToParcellaComponent,
    ParcellaEntityViewComponent,
    FatturaEntityViewComponent,
    DocumentUpdateMetadatiModal,
    DocumentUpdateMetadatiFormComponent,
    DocumentVersionUpdateFormComponent,
    DefineFascicoloComponent,
    DeletePraticaComponent,
    EsitiMeritoAddMod,
    EsitiMeritoUpdate,
    BeniImmobiliModAddComponent,
    BeniImmobiliModUpdateComponent,
    BeniImmobiliAddComponent,
    BeniImmobiliUpdateComponent,
    LettereDiffidaAddComponent,
    LettereDiffidaAddMod,
    LettereDiffidaEsitoSpedizioneAddComponent,
    LettereDiffidaEsitoSpedizioneAddMod,
    LettereDiffidaEsitoSpedizioneUpdate,
    LettereDiffidaEsitoSpedizioneUpdateMod,
    LettereDiffidaDatiGeneraliComponent,
    LettereDiffidaDatiGeneraliUpdateMod,
    AddDocumentoToLetteraDiffidaComponent,
    LetteraDiffidaEntityViewComponent,
    ProvaScrittaModAddComponent,
    ProveScritteAddFormComponent,
    BeniMobiliAddComponent,
    BeniMobiliModAdd,
    ProveScritteAddFormComponent,
    ProvaScrittaUpdateConcreteFormComponent,
    ProvaScrittaMoldaUpdateComponent,
    TitoloModAddComponent,
    TitoloAddFormComponent,
    TitoloMoldaUpdateComponent,
    TitoloUpdateConcreteFormComponent,
    AddDocumentoToProvaScrittaComponent,
    ProvaScrittaEntityViewComponent,
    BeniMobiliUpdateComponent,
    BeniMobiliModUpdate,
    AddDocumentoToTitoloEsecutivoComponent,
    TitoloEsecutivoEntityViewComponent,
    BeneImmobileEntityViewComponent,
    AddDocumentoToBeneImmobileComponent,
    AddDocumentoToBeneMobileComponent,
    BeneMobileEntityViewComponent,
    CorrelaPraticaComponent,
    CopiaPraticaComponent,
    AssegnazioneCompetenzaFormComponent,
    AssegnatariModalComponent,
    RifiutoComponent,
    FooterFascicoloWizardComponent,
    IstanzaRisultatoPraticaComponent,
    RiunisciGiudiziComponent,
    Pathbar,
    PathbarLemComponent,
    ExportHelpComponent,
    SpinnerLoadComponent,
    ArchiviaModal,
    AutorizzazioniViewComponent,
    TemplateUtenteUpdateComponent,
    TemplateUtenteModUpdateComponent,
    TemplateUtenteAddComponent,
    TemplateUtenteModAddComponent,
    UtenteUpdateComponent,
    UtenteModUpdateComponent,
    UtenteAddComponent,
    UtenteModAddComponent,
    RiunioneGiudiziModEdit,
    RiunioneGiudiziEditComponent,
    OptionFascicoloComponent,
    OptionPraticaComponent,
    OptionCensimentoDocumentiComponent,
    ConfermaCambioFrComponent,
    SanitizerUrlPipe,
    DatiFascicoloComponent,
    NgbModule,
    FilterItemMenuHidePipe,
    FilterSearchPipeAmm,
    PaginationPipe,
    PaginatorComponent,
    MultiSelectComponent,
    ListFilterPipe,
    CreazioneRapidaComponent,
    TitleAmiantoPipe,
    UnderscoreToSpacePipe,
    ItemNewPraticaPipe,
    PraticheCorrelateCreateComponent,
    PraticaCreateDatiClassificazioneDefaultComponent,
    PatologieModAggiungi,
    PatologiaEntityViewComponent,
    AddDocumentoToPatologiaComponent,
    MultiFilterPipe,
    DatiGeneraliAnagraficheComponent,
    AssociativaContropartiComponent,
    AssociativaSoggettiTerziComponent,
    DatiGeneraliAnagraficheSearchComponent,
    SpeseLegaliAddComponent,
    SpeseLegaliModUpdate,
    SpeseLegaliFormUpdateComponent,
    SpeseLegaliFormAddComponent,
    ValoreEconomicoViewComponent,
    FondoRischiViewComponent,
    LiquidatiViewComponent,
    FilterTenantItemPipe,
    LegaliDetaglioTariffaModalComponent,
    OptionsMenuComponent,
    OfficeEditorComponent,
    TreeviewComponentComponent,
    DetailFolderFileComponent,
    InfoSocietaModalComponent,
    DatiGeneraliFascicoloCommonComponent,
    DatiGeneraliFascicoloGiudizialeCommonComponent,
    SpeseGiudizioFormComponent,
    CensimentoDocumentiFormComponent,
    CensimentoDocumentiAddComponent,
    CensimentoDocumentiEditComponent,
    PersonalizzazioneDannoBiologicoViewComponent,
    PersonalizzazioneDannoBiologicoEditModalComponent,
    DatiPignoramentoAddComponent,
    DatiPignoramentoModAdd,
    DatiPignoramentoUpdateComponent,
    DatiPignoramentoModUpdate,
    DatiPignoramentoEntityViewComponent,
    AddDocumentoToDatiPignoramentoComponent,
    ListaDocumentiTipoDocumentoComponent,
    Sole24OreComponent,
    DettaglioSole24OreComponent,
    PaginationComponent,
    ReplaceLineBreaks,
    BooleanTransformPipe,
    TipoPraticaPipe,
    InsertionHostDirective,
    SwitchComponent,
    PickListComponent,
    MetadataViewComponent,
    ModalMetadataAddComponent,
    PaginationDocumentComponent,
    DynamicFormFieldComponent,
    MetadataDynamicFormComponent,
    FascicoloMetadataFormComponent,
    PraticaMetadataFormComponent,
    MetadataDynamicViewComponent,
    ProtocolFascicoloFormComponent,
    ProtocollaDocumentoModalComponent,
    ProtocolFascicoloInsertComponent,
    SignDocumentFormComponent,
    UploadToolComponent,
    CreazionePraticaStepperComponent,
    StepDatiGenPraticaComponent,
    ClassificazioneFormComponent,
    ClassificazioniComponent,
    DatiGenPraticaFormComponent,
    TipoPraticaWidgetComponent,
    StepDatiGenFascicoloComponent,
    StepPartiComponent,
    StepSoggettiTerziComponent,
    StepDatiEconomiciComponent,
    PetitumFormComponent,
    StepAttiComponent,
    StepAdempimentiFormComponent,
    StepAdempimentiListComponent,
    StepAdempimentiComponent,
    StepDocumentazioneAllegataComponent,
    StepAttiFormComponent,
    StepSoggettiTerziListComponent,
    StepSoggettiTerziFormComponent,
    ListPartiComponent,
    AnagraficaParteFormComponent,
    AssociazioneControparteFormComponent,
    ListContropartiComponent,
    AddFolderFormComponent,
    NewDocumentFormComponent,
    StepSoggettiTerziFormAssociativaComponent,
    StepSoggettiTerziListAltrepartiComponent,
    StepPartiFormInserimentoComponent,
    AttiListViewComponent,
    TooltipDirective,
    CleanInputDirective,
    NgxPrintDirective,
    DetailFolderFileOptionComponent,
    OptionFileComponentComponent,
    OptionDirComponentComponent,
    MarkDocumentDialogComponent,
    SignDocumentDialogComponent,
    ViewDocumentDialogComponent,
    EmlPreviewComponent,
    ZipPreviewComponent,
    // PdfPreviewComponent,
    PdfReaderComponent,
    DropdownFocusDirective,
    InviaNotificaModalComponent,
    SelezioneFascicoliSecondariComponent,
    AnnullaDocumentoProtocolloComponent,
    DocumentUploadedComponent,
    UpdateMetadatiConservazioneComponent,
    GestioneMetadatiFascicoloComponent,
    DocumentoDettaglioMetadatoModalComponent
  ],
  entryComponents: [
    StepAdempimentiComponent,
    StepAttiComponent,
    StepDatiEconomiciComponent,
    StepDatiGenPraticaComponent,
    StepDocumentazioneAllegataComponent,
    StepDatiGenFascicoloComponent,
    StepPartiComponent,
    StepSoggettiTerziComponent
  ]
})

export class CommonTLFModule {}

